import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-step-input',
  templateUrl: './step-input.component.html',
  styleUrls: ['./step-input.component.scss']
})
export class StepInputComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
